import React from 'react'
import { DrillLoader, DrillsCategoriesLoader } from 'loaders'
import PropTypes from 'prop-types'
import DrillEditContainer from '../../containers/ActivitiesEditContainer'

const ActivityEditPage = ({
  history,
  match: {
    params: { drillUuid },
  },
  match,
  location,
}) => (
  <DrillLoader drillUuid={drillUuid} alwaysRenderChildren passIsLoading>
    <DrillsCategoriesLoader>
      <DrillEditContainer history={history} match={match} location={location} />
    </DrillsCategoriesLoader>
  </DrillLoader>
)

ActivityEditPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      drillUuid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default ActivityEditPage
